import { render, staticRenderFns } from "./CustomVueTablePaginationBootstrap.vue?vue&type=template&id=5c322416&"
import script from "./CustomVueTablePaginationBootstrap.vue?vue&type=script&lang=js&"
export * from "./CustomVueTablePaginationBootstrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports